export const MOCK_USER_KEY = 'onward_mock_user';

export const getMockUser = () => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(MOCK_USER_KEY);
};

// Spread into axios header objects: returns {} when no mock user is
// stored, so the X-Mock-User header is omitted entirely rather than
// silently defaulting to a shared "demo-user" identity.
export const mockAuthHeaders = () => {
  const u = getMockUser();
  return u ? { 'X-Mock-User': u } : {};
};
